module.exports = __webpack_public_path__ + "img/logo_shuanghe.bd0d002e.png";